import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./i18n/profile-creation-side-finished.i18n.json'));

type Props = {};

const steps = [
  { type: 'get_started', link: 'https://help.collabary.com/content-creators/is-collabary-for-me/how-to-get-started' },
  { type: 'recieve_invintation', link: 'https://help.collabary.com/content-creators/the-campaign-flow/receiving-campaign-invitations' },
  { type: 'campaign_works', link: 'https://help.collabary.com/content-creators/miscellaneous/how-do-campaigns-work' }
];

class ProfileCreationSideFinishedFaq extends React.PureComponent<Props> {
  render() {
    return (
      <div className="profile-creation-side-finished-faq">
        <div className="profile-creation-side-finished-faq__heading">
          {__t('profile_creation_side_finished.faq_heading')}
        </div>
        <div className="profile-creation-side-finished-faq__content">
          {
            steps.map(step => (
              <a
                key={step.type}
                href={step.link}
                target="_blank"
                rel="noopener noreferrer"
                className="profile-creation-side-finished-faq__link"
              >
                {__t(`profile_creation_side_finished.step_${step.type}`)}
              </a>
            ))
          }
        </div>
      </div>
    );
  }
}

export default ProfileCreationSideFinishedFaq;
